/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFinancialListCreate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v12h-2V8H4v12h10v2H2zm2 4h16V4H4zm4 4h-.463C6.177 10 5 11.037 5 12.5c0 .64.201 1.268.636 1.748.444.49 1.068.752 1.754.752H8v1H6v2h2v1h2v-1h.463C11.823 18 13 16.963 13 15.5c0-1.462-1.177-2.5-2.537-2.5H10v-1h2v-2h-2V9H8zm0 3h-.61c-.162 0-.233-.053-.272-.096C7.07 12.852 7 12.73 7 12.5c0-.277.199-.5.537-.5H8zm2 2h.463c.338 0 .537.223.537.5s-.199.5-.537.5H10zm8-3h-4v-2h4zm0 3h-4v-2h4zm0 3h-2v2h2v2h2v-2h2v-2h-2v-2h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFinancialListCreate as FinancialListCreate };
